<template>
	<div>
		<v-row class="mb-5">
			<v-col cols="8" md="6">
				<v-text-field
				v-model="subscription_plan_search_query"
				:placeholder="$lang.SUBSCRIPTION_SEARCH"
				outlined
				rounded
				dense
				@keyup="getSubscriptionPlanList(true)"
				hide-details
				append-icon="mdi-magnify"
				></v-text-field>
			</v-col>
			<v-col cols="4" md="6" class="text-right" >
				<span @click="$router.push({name:'add-a-subscription-plan'})" class="cursor-pointer" v-if="$store.state.user_type!=$keys.WHOLESALER">
					<span class="secodry-text-4 mr-3 ">{{$lang.CREATE_NEW_PLAN.toUpperCase()}}</span>
					<v-btn color="primary" fab small depressed >	
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</span>
			</v-col>
		</v-row>

		<div>
			<v-data-table
			:headers="headers"
			:items="subscription_plans"
			:hide-default-footer="true"
			:disable-sort="true"
			:items-per-page="$keys.PAGE_LENGTH"
			class="elevation-1 custome-header-bg custome-table-body"
			:loading="table_loading"
			>
			<template v-slot:item.type="{ item }">
				<span v-if="item.type">{{item.type}}</span>
				<span v-else>-</span>
			</template>	
			<template v-slot:item.action="{ item }">
				<div v-if="$store.state.user_type!=$keys.WHOLESALER">

					<v-btn small fab text @click="$router.push({name:'edit-subscription-plan',params:{subscription_plan_id:encript(item.id)}})">
						<img src="@/assets/edit.svg" alt="img">
					</v-btn>	
					<v-btn small fab text class="ml-2"
					@click="confirmDeletePlan(item)">	
					<img src="@/assets/delete.svg" alt="img">
				</v-btn>	
			</div>
		</template>	
		<!-- empty slot  -->
		<template v-slot:no-data>
			<empty-list :message="$lang.EMPTY_SUBSCRIPTION" :type="$keys.EMPTY_TYPE_2"/>
		</template>


	</v-data-table>

	<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
	@input="subscription_plans"></v-pagination>

</div>

<confirm-delete-dialog :dialog="dialog" :deleteSubscriptionPlan="deleteSubscriptionPlan"/>

</div>
</template>

<script type="text/javascript">
export default {
	components: {
		// ConfirmationPopup:()=> import('./child/ConfirmationPopup.vue'),

		ConfirmDeleteDialog:()=>import('./child/ConfirmDeleteDialog.vue')
	},

	data () {
		return {
			total_page_count:1,
			page_number:1,
			table_loading:false,
			subscription_plans:[],
			subscription_plan_search_query:"",
			headers: [
			{ text: 'Name', align: 'start', value: 'name'},
			{ text: 'Price', value: 'price' },
			{ text: 'Days', value: 'validity' },
			{ text: 'Type', value: 'type' },
			{ text: 'No of Shipments Allowed', value: 'shipment_count' },
			{ text: 'Plan Type', value: 'plan_type' },
			// { text: 'Subscribers', value: 'subscribers' },
			{ text: '', value: 'action' },
			],
			/*FILTER*/
			filter_data:{
				retailer_id_list:[],
				status_list:[],
				type_list:[],
				filter_date_from:"",
				filter_date_to:"",
			},
			dialog:{
				flag:false,
				plan:null,
			}


		}
	},
	created(){
		this.getSubscriptionPlanList(false);
	},
	methods:{
		/* fetch subscription plan list */ 
		getSubscriptionPlanList(is_cancel=true){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				search_query:this.subscription_plan_search_query,
			};

			const successHandler = (response) => {
				if (response.data.success){
					self.subscription_plans=response.data.subscription_list
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.SUBSCRIPTON_LIST,params,successHandler,null,null,finallyHandler,is_cancel)

		},
		confirmDeletePlan(plan){
			this.dialog.flag=true
			this.dialog.plan=plan

		},
		deleteSubscriptionPlan(){
			const self=this
			let params={
				id:this.dialog.plan.id,
			};
			self.btn_loading=true;
			const successHandler = (response) => {
				self.dialog.plan="";
				self.dialog.flag=false;
				this.getSubscriptionPlanList()
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};
			self.request_GET( self,self.$urls.DELETE_SUBSCRIPTION_PLAN,params,successHandler,null,null,finallyHandler)


		}
	}
}


</script>